<template>
  <q-page
    :data-test="CypressTarget('HelpPage')"
    padding
  >
    <h4>{{ $t($route.meta.pageName) }}</h4>
    <q-list
      :data-test="CypressTarget('FAQList')"
    >
      <item-help-collapsible-faq
        v-for="(help, index) in helpItems"
        :key="index"
        :title="help.title"
        :content="help.content"
      />
    </q-list>
  </q-page>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import ItemHelpCollapsibleFaq from 'components/item/help/collapsibleFaq';

  export default {
    name: 'HelpIndex',
    components: {
      ItemHelpCollapsibleFaq,
    },
    computed: {
      ...mapGetters('help', [
        'helpItems',
      ]),
    },
    async created() {
      document.title = `${this.SET_PAGE_NAME} | ${this.$t('page.help')}`;
      try {
        await this.gethelp();
      } catch (error) {
        this.toastError(error);
      }
    },
    mounted() {
      this.$tracker.pageView({
        page: this.$route.path,
        title: this.$t('page.help'),
      });
    },
    methods: {
      ...mapActions('help', [
        'gethelp',
      ]),
    },
  };
</script>
